import { apiFetch } from "./index";
import { getApiBaseUrl } from "./baseUrl";
const API_BASE = getApiBaseUrl();

export const getBannerInfo = async (token: string) => {
  return await apiFetch<BannerInfo>(`${API_BASE}/api/management/deadline-banner`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export interface BannerInfo {
  deadline_days: number;
  banner_message: string;
}
